import { API } from "./axiosInstance"

/**
 * Gets all the applicationAuthenticationMethods for one application from usermanagement-service
 * @param {*} staticMemberId The application to get all the applicationAuthenticationMethods for
 * @returns the applicationAuthenticationMethods with joined objects
 */
export const getApplicationAuthenticationMethodsByApplication = async (staticApplicationId) => {
    const appAuthMethods = await API.get(`/applicationsAuthenticationMethods?applicationId=${staticApplicationId}`);
    return appAuthMethods.data;
}

/**
 * Gets a single applicationAuthenticationMethods from usermanagement-service
 * @param {*} id The id to find
 * @returns the applicationAuthenticationMethods with joined objects
 */
 export const getApplicationAuthenticationMethodsById = async (id) => {
    const appAuthMethod = await API.get(`/applicationsAuthenticationMethods/${id}`);
    return appAuthMethod.data;
}


/**
 * Calls the post applicationsAuthenticationMethods endpoint
 * @param {*} applicationAuthenticationMethod the applicationAuthenticationMethod to create
 * @returns the response from usermanagement-service
 */
export const createApplicationAuthenticationMethod = async (applicationAuthenticationMethod) => {
    const response = await API.post(`/applicationsAuthenticationMethods`, applicationAuthenticationMethod);
    return response.data;
}

/**
 * Calls the post applicationsAuthenticationMethods endpoint
 * @param {*} applicationAuthenticationMethod the applicationAuthenticationMethod to create
 * @param {*} staticId The id to update
 * @returns the response from usermanagement-service
 */
export const updateApplicationAuthenticationMethod = async (applicationAuthenticationMethod, staticId) => {
    const response = await API.put(`/applicationsAuthenticationMethods/${staticId}`, applicationAuthenticationMethod);
    return response.data;
}


/**
 * Accepts a requested change for a applicationAuthenticationMethod
 * @param {*} staticId the id of the applicationAuthenticationMethod in the static model
 * @returns the accepted applicationAuthenticationMethod
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/applicationsAuthenticationMethods/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a applicationAuthenticationMethod
 * @param {*} staticId the id of the applicationAuthenticationMethod in the static model
 * @returns the rejected applicationAuthenticationMethod
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/applicationsAuthenticationMethods/${staticId}/reject`);
    return response.data;
}